
















import Vue from 'vue'
import { WidgetSettingsCheckbox, WidgetSettingType } from '../../widgets/base/widget/WidgetInterface'
import SettingsPanelCustomCheckbox from '../SettingsPanelCustomCheckbox.vue'
import { SettingsPanelCustomCustomMixin } from './SettingsPanelCustomCustomMixin'

export default Vue.extend({
  mixins: [SettingsPanelCustomCustomMixin],
  components: {
    SettingsPanelCustomCheckbox
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    const config = {
      notification_type: '2',
      usingGroups: [] as any[]
    }

    this.syncConfigProperties(config, this.data)

    return {
      config: config,
      availableGroups: this.getAvailableGroups(config.usingGroups)
    }
  },
  methods: {
    getAvailableGroups(selectedGroups: number[] = []): WidgetSettingsCheckbox[] {
      const cluster = this.$store.state.cluster
      const groupIds = cluster.groupsorting
      const result: any[] = []

      groupIds.forEach(groupId => {
        if (!cluster.group[groupId]) {
          return
        }
        const group = cluster.group[groupId]
        result.push({ type: WidgetSettingType.checkbox, title: group.name, checked: selectedGroups.indexOf(groupId) > -1, value: groupId })
      })

      return result
    }
  },
  updated() {
    const groups = this.availableGroups
    const config = this.config

    config.usingGroups = []

    groups.forEach(group => {
      if (!group.checked) {
        return
      }
      config.usingGroups.push(group.value)
    })

    this.$emit('update', this.config)
  }
})
